'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicOptions = undefined;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _radio = require('../components/radio');
var _radio2 = _interopRequireDefault(_radio);
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var basicOptions = exports.basicOptions = [{
  text: 'Full UK licence',
  value: 'F'
}, {
  text: 'Provisional licence',
  value: 'P'
}];
TypeOfLicence.propTypes = {
  options: _propTypes.array,
  label: _propTypes.string
};
TypeOfLicence.defaultProps = {
  options: basicOptions,
  label: 'What type of driving licence do you have?'
};
function TypeOfLicence(_ref) {
  var options = _ref.options,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, ['options', 'label']);
  return _react2.default.createElement(_radio2.default, Object.assign({
    name: 'licenceType',
    label: label,
    options: options
  }, rest));
}
exports.default = TypeOfLicence;